import { IRoadIdentifierIconProps } from "../ManeuverLabel";

export function EuropaveiIcon(props: IRoadIdentifierIconProps) {
    const roadIdentifier = props.roadIdentifier;
    return (
        <span className={"europavei-icon"}>{roadIdentifier}</span>
    );
}